<template>
  <div>

      <b-alert  :show="dismissCountDown"  :variant="typeAlert" @dismissed="dismissCountDown=0"
             @dismiss-count-down="countDownChanged" class="alert">
        {{textAlert}}
      </b-alert>





  </div>
</template>
<script>
export default {
  name: 'Alerts',
  props: {
    lang: Object
  },
  data() {
    return {
      dismissSecs: 5,
      dismissCountDown: 5,

      typeAlert: 'success',
      textAlert: this.lang["1"]
    }
  },
  computed:{
    alertContainer(){
      return this.$store.getters.alertContainer
    }
  },
  methods: {
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    }
  },
  watch: {
    alertContainer: function (new_Data, old_Data) {
      this.textAlert = new_Data.text;
      this.typeAlert = new_Data.type;
      this.dismissSecs = new_Data.time;
      this.showAlert();

      let obj = {
        "type": new_Data.type,
        "message": new_Data.text,
        "user": this.$store.getters.currentUser.userId
      }

      this.$store.dispatch("setAlert", obj)
        .then(function(result) {
          console.log("setAlert", result);
        });
    }
  }
}
</script>
<style scoped>
  .alert{
    border: 1px solid #aaa;
  }

</style>



// WEBPACK FOOTER //
// src/components/Footer/Alerts.vue